export default __webpack_public_path__ + "static/media/site-blogs.25cd5f0c.png";